import React from 'react';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import PropTypes from 'prop-types';

import AgendaSummaryBody from './AgendaSummaryBody';
import AgendaSummaryData from './AgendaSummaryData';

const AgendaSummaryEdit = (props) => {
  const { block, data, properties, selected } = props;

  return (
    <>
      <AgendaSummaryBody
        block={block}
        data={data}
        properties={properties}
        isEditMode
      />
      <SidebarPortal selected={selected}>
        <AgendaSummaryData key={block} {...props} data={data} block={block} />
      </SidebarPortal>
    </>
  );
};

AgendaSummaryEdit.propTypes = {
  block: PropTypes.string,
  data: PropTypes.object,
  properties: PropTypes.object,
  selected: PropTypes.bool,
};

export default AgendaSummaryEdit;
